import React from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import styled from 'styled-components';
import { media } from 'styles/breakpoints';

const Container = styled.div`
  position: relative;
  padding-top: 56.25%;
  margin: 40px 0;

  ${media.medium`
    padding: 0;
  `};
`;

const StyledReactPlayer = styled(ReactPlayer)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
  max-width: 640px;
  max-height: 360px;

  ${media.medium`
    position: inherit;
    transform: none;
    width: 640px !important;
    height: 360px !important;
  `};
`;

export default function VideoPlayer({ url }) {
  if (!url) return null;
  return (
    <Container>
      <StyledReactPlayer controls={true} url={url} width="100%" height="100%" />
    </Container>
  );
}

VideoPlayer.propTypes = {
  url: PropTypes.string
};

VideoPlayer.defaultProps = {
  url: null
};



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/VideoPlayer.js